<module-container>
  <div class="title-container">
    <h2>Source Configuration</h2>
  </div>
  <abcis-table [configuration]="tableConfig" (actionClick)="onActionClick($event)"></abcis-table>

  <p-dialog
    [(visible)]="showResumeConfirm"
    [modal]="true"
    [closable]="false"
    [dismissableMask]="true"
    [style]="{ width: '460px', maxWidth: '92vw' }"
    styleClass="resume-confirm-dialog"
  >
    <div class="resume-confirm-body">
      <div class="resume-confirm-icon">
        <i class="pi pi-exclamation-circle"></i>
      </div>
      <div class="resume-confirm-content">
        <div class="resume-confirm-title">Resume OCR Import</div>
        <div class="resume-confirm-subtitle">
          This will import documents that are currently under 'Import Disabled' OCR status for this
          store and source type.
        </div>
        <div class="resume-confirm-message">Are you sure you want to proceed?</div>
      </div>
    </div>
    <div class="resume-confirm-actions">
      <button
        pButton
        type="button"
        class="p-button-danger"
        icon="pi pi-play"
        label="Yes, Resume Import"
        (click)="confirmResumeImport()"
      ></button>
      <button
        pButton
        type="button"
        class="p-button-outlined p-button-secondary"
        label="Cancel"
        (click)="cancelResumeImport()"
      ></button>
    </div>
  </p-dialog>
</module-container>
